import { Client } from "@/Common/Api/Client";
import * as ServerOperations from "@/Common/Operations/operations.server";

export class VigilanceTokenClient {
    private static token: string;
    private static expirationDate: Date;

    public static async getVigilanceTokenAsync(): Promise<string> {
        const now = new Date();

        if (!this.token || this.expirationDate <= now) {
            const response = await Client.postAsync<{ Token: string, ExpiresIn: number }>(
                ServerOperations.Server.MedfarDictionary_GetVigilanceToken,
                {}
            );

            this.token = response.data.Token;
            this.expirationDate = now.addSeconds(response.data.ExpiresIn - 30);
        }

        return this.token;
    }
}
